<template>
	<div class="main">
		<header class="page-title">
			<h2>Commercial <span class="page-description"><i class="fas fa-info-circle icon-left"></i> The settings on this tab apply to the whole article</span>
			</h2>
			<div class="ml-auto">
				<button @click.prevent="startSave" class="btn btn-md btn-success">
					<i class="fas fa-save"></i> Save Changes
				</button>
			</div>
		</header>
		<div class="article-commercial-container">
			<div>
				<article-commercial-summaries
						:commercial-summaries="data.articleCommercialSummaries"
				></article-commercial-summaries>
				<article-commercial-recommended-providers
						:commercial-recommended-providers="data.articleCommercialRecommendedProviders"
				></article-commercial-recommended-providers>
			</div>
			<div>
				<article-commercial-technical
						:commercial-technical="data.articleCommercialTechnical"
				></article-commercial-technical>
			</div>
		</div>
	</div>
</template>

<script>
	import {eventBus} from "../../app";

	export default {
		props: {
			data: {
				required: true
			}
		},
		methods: {
			startSave: function () {
				let vm = this;
				let currentDateWithFormat = new Date().toJSON().slice(0, 10).split('-').reverse().join('/');
				this.$dialog.confirm('Do you want to update the displayed date of the article to ' + currentDateWithFormat + '?', {
					okText: 'Yes',
					cancelText: 'No',
				}).then(function () {
					vm.saveCommercial(true);
				}).catch(function () {
					vm.saveCommercial(false);
				});
			},
			saveCommercial: function(updateDisplayDate) {
				let vm = this;
				vm.data['display_date'] = updateDisplayDate;
				eventBus.$emit('onLoaderStart');
				axios.post('/api/' + vm.$selectedSite.slug + '/articles/' + vm.data.id + '/saveCommercial', vm.data)
					.then(function (response) {
						if (response.data) {
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.success('Article commercial saved.', 'Success');
						}
					})
					.catch(function (e) {
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.error('Article draft save failed.', 'Error');
					});
			}
		}
	}
</script>

<style scoped>

</style>
